// https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
const defaultBaseline = {
  boxSizing: 'border-box',
  padding: 0,
  margin: 0,
  listStyle: 'none',
};

export default defaultBaseline;
